import React from 'react';
import ListItem, { ListItemProps } from '@material-ui/core/ListItem';
import { NavLink as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';
import { Omit } from '@material-ui/types';

interface ListItemLinkProps extends ListItemProps {
  to: string;
  classNameNavItem: string;
}

export const ListItemLink: React.FC<ListItemLinkProps> = (props: ListItemLinkProps) => {
  const { to, classNameNavItem } = props;

  const shouldNavigate: boolean = to !== '' && to !== undefined;

  const renderLink = React.useMemo(
    () =>
      React.forwardRef<any, Omit<RouterLinkProps, 'to'>>((itemProps, ref) => (
        <RouterLink to={to} ref={ref} {...itemProps} />
      )),
    [to]
  );

  const handleClick = (e: any) => {
    props.onClick !== undefined && props.onClick(e);
  };

  return (
    <li className={classNameNavItem}>
      {shouldNavigate ? (
        <ListItem component={renderLink} button onClick={handleClick} className={props.className}>
          {props.children}
        </ListItem>
      ) : (
        <ListItem button onClick={handleClick} className={props.className}>
          {props.children}
        </ListItem>
      )}
    </li>
  );
};
